import { Timestamp } from "firebase/firestore";

export const truncateText = (
  text: string,
  startChars: number,
  endChars: number
) => {
  if (!text) return "";
  const truncatedText =
    text.length > startChars + endChars
      ? text.substring(0, startChars) +
      "....." +
      text.substring(text.length - endChars)
      : text;
  return truncatedText;
};

export function formatRelativeTime(timestamp: any): string {
  const currentTime: any = Math.floor(Date.now() / 1000); // Current time in seconds
  const timestampInSeconds: any = Math.floor(timestamp); // Convert Firebase timestamp to seconds
  const secondsAgo = currentTime - timestampInSeconds;

  if (secondsAgo < 60) {
    return secondsAgo + " sec" + (secondsAgo !== 1 ? "s" : "") + " ago";
  }

  const minutesAgo = Math.floor(secondsAgo / 60);
  if (minutesAgo < 60) {
    return minutesAgo + " min" + (minutesAgo !== 1 ? "s" : "") + " ago";
  }

  const hoursAgo = Math.floor(minutesAgo / 60);
  if (hoursAgo < 24) {
    return hoursAgo + " hour" + (hoursAgo !== 1 ? "s" : "") + " ago";
  }

  const daysAgo = Math.floor(hoursAgo / 24);
  if (daysAgo < 30) {
    return daysAgo + " day" + (daysAgo !== 1 ? "s" : "") + " ago";
  }

  const monthsAgo = Math.floor(daysAgo / 30);
  if (monthsAgo < 12) {
    return monthsAgo + " month" + (monthsAgo !== 1 ? "s" : "") + " ago";
  }

  const yearsAgo = Math.floor(monthsAgo / 12);
  return yearsAgo + " year" + (yearsAgo !== 1 ? "s" : "") + " ago";
}

export const convertFirebaseTimestamp = (
  firebaseTimestamp: any
): string | null => {
  if (!firebaseTimestamp || !(firebaseTimestamp instanceof Timestamp)) {
    return null; // Return null or handle the error as per your requirement
  }

  const date = firebaseTimestamp.toDate();

  const options: Intl.DateTimeFormatOptions = {
    month: "numeric",
    day: "numeric",
    year: "numeric",
    hour: "numeric",
    minute: "numeric",
  };
  const formattedDate: string = date.toLocaleDateString("en-US", options);

  return formattedDate;
};
